export const getHashFromLink = (str) => {
    return str.split('/').pop().split('?' || '')[0]
}